<script lang="ts">
  import * as Command from "$lib/components/ui/command/index.js";
  import * as Popover from "$lib/components/ui/popover/index.js";
  import { Button } from "$lib/components/ui/button/index.js";
  import { createEventDispatcher, getContext, onMount, tick } from "svelte";
  import CaretSort from "svelte-radix/CaretSort.svelte";
  import { type StoreSummary } from "$src/domain/directory/stores/StoreSummary";
  import { ContextTokens } from "../contexts/ContextTokens";
  import { type AuthContext } from "$src/infrastructure/accounts/AuthContext";
  import Check from "svelte-radix/Check.svelte";
  import { cn } from "$lib/utils";
  import { get } from "svelte/store";

  let open = false;

  let { activeGroupStore }: AuthContext = getContext(ContextTokens.Auth);

  export let value: StoreSummary | undefined;

  const dispatch = createEventDispatcher();
  
  onMount(() => {

    var activeGS = get(activeGroupStore);
    if( activeGS && activeGS.stores.length > 0) {
        value = activeGS.stores[0];
    }
  })

  // We want to refocus the trigger button when the user selects
  // an item from the list so users can continue navigating the
  // rest of the form with the keyboard.
  function closeAndFocusTrigger(triggerId: string) {
    open = false;
    tick().then(() => {
      document.getElementById(triggerId)?.focus();
    });
  }
</script>

{#if $activeGroupStore}
  <Popover.Root bind:open let:ids>
    <Popover.Trigger asChild let:builder>
      <Button
        builders={[builder]}
        variant="outline"
        role="combobox"
        aria-expanded={open}
        class="w-[200px] justify-between"
      >
        {value?.name}
        <CaretSort class="ml-2 h-4 w-4 shrink-0 opacity-50" />
      </Button>
    </Popover.Trigger>
    <Popover.Content class="w-[200px] p-0">
      <Command.Root>
        <!-- <Command.Input placeholder="Search framework..." class="h-9" />
        <Command.Empty>No framework found.</Command.Empty> -->
        <Command.Group>
          {#each $activeGroupStore.stores as store}
            <Command.Item
              value={store.storeId.toString()}
              onSelect={(currentValue) => {
                value = $activeGroupStore.stores.find(s => s.storeId.toString() == currentValue);
                dispatch('storeSelected', value);
                closeAndFocusTrigger(ids.trigger);
              }}
            >
              <Check
                class={cn(
                  "mr-2 h-4 w-4",
                  value?.storeId !== store.storeId && "text-transparent"
                )}
              />
              {store.name}
            </Command.Item>
          {/each}
        </Command.Group>
      </Command.Root>
    </Popover.Content>
  </Popover.Root>
{/if}
